import { render } from "./ModalPopup.vue?vue&type=template&id=660cd262&scoped=true&ts=true"
import script from "./ModalPopup.vue?vue&type=script&lang=ts"
export * from "./ModalPopup.vue?vue&type=script&lang=ts"

import "./ModalPopup.vue?vue&type=style&index=0&id=660cd262&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660cd262"]])

export default __exports__